<template>
  <div class="auth">
    <header class="auth__header">
      <router-link :to="translations.i18nRoute({ name: 'home' })">
        <img src="@icons/logo.svg" alt="logo">
      </router-link>
    </header>
    <RouterView v-slot="{ Component }">
      <Transition name="opacity" mode="out-in">
        <component :is="Component" />
      </Transition>
    </RouterView>
  </div>
</template>

<script setup>
import translations from "@/core/helpers/translations.js";
</script>

<style lang="scss" scoped>
.auth {
  &__header {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-block: 10px;
    background-color: $black;
  }
}
</style>